export const translations = {
  en: {
    // Global
    'global.of': 'of',
    'global.with': 'with',

    // Share
    'share.intro': 'Check out my workout!',
    'share.outro': 'You can also use LiftIQ to track your workouts at https://liftiq.es!',

    // Units
    'units.minutes': 'minutes',
    'units.seconds': 'seconds',
    'units.reps': 'reps',
    'units.kg': 'kg',
    'units.lbs': 'lbs',
    'units.cm': 'cm',
    'units.in': 'in',

    // Categories
    'category.title': 'Manage Categories',
    'category.new': 'New Category',
    'category.edit': 'Edit Category',
    'category.delete': 'Delete Category',
    'category.name': 'Category Name',
    'category.deleteConfirm': 'Are you sure you want to delete this category? It will be removed from all associated exercises.',
    'category.deleteError': 'Cannot delete category that is in use.',
    'category.addError': 'Failed to add category',
    'category.updateError': 'Failed to update category',
    'category.cancel': 'Cancel',
    'category.save': 'Save',
    'category.close': 'Close',
    'category.nameRequired': 'Category name is required',
    'category.subtitle': 'Categories',

    // Navigation
    'nav.calendar': 'Calendar',
    'nav.summary': 'Summary',
    'nav.exercises': 'Exercises',
    'nav.bodyweight': 'Body Weight',
    'nav.routines': 'Routines',
    'nav.programs': 'Programs',
    'nav.friends': 'Friends',
    'nav.chat': 'Chat',
    'nav.evaluation': 'Evaluations',
    'nav.profile': 'Profile',
    'nav.releaseNotes': 'Release Notes',
    'nav.logout': 'Logout',
    'nav.appTitle': 'Lift IQ',

    // Logout Dialog
    'logout.title': 'Confirm Logout',
    'logout.message': 'Are you sure you want to logout? You will need to sign in again to access your data.',
    'logout.cancel': 'Cancel',
    'logout.confirm': 'Logout',

    // Login
    'login.title': 'Lift IQ',
    'login.subtitle': 'Track your workouts and monitor your progress',
    'login.sessionExpired': 'Session Expired',
    'login.sessionExpiredMessage': 'Your session has expired. Please sign in again to continue.',
    'login.accessDenied': 'Access Denied',
    'login.accessDeniedMessage': 'You are not authorized to use this application.',
    'login.googleError': 'Google Sign-In script failed to load. Please check your internet connection or try refreshing.',
    'login.signingIn': 'Signing in...',

    // Calendar
    'calendar.selectDate': 'Select a date to log your workout',
    'calendar.workoutsFor': 'Workouts for',
    'calendar.bodyWeight': 'Body Weight',
    'calendar.noBodyWeight': 'No body weight recorded for this date',
    'calendar.addWorkoutEntryButton': 'Add Workout Entry',
    'calendar.addWorkoutEntry': 'Add Workout Entry',
    'calendar.addWorkout': 'Add Workout',
    'calendar.smartActions': 'Smart Actions',
    'calendar.addWorkoutEntryTitle': 'Add New Workout Entry',
    'calendar.editWorkoutEntryTitle': 'Edit Workout Entry',

    // Workout Form
    'workout.exercise': 'Exercise',
    'workout.series': 'Series',
    'workout.reps': 'Reps',
    'workout.weight': 'Weight (kg)',
    'workout.comment': 'Comment',
    'workout.addSet': 'Add Set',
    'workout.editSet': 'Edit Set',
    'workout.edit': 'Edit',
    'workout.delete': 'Delete',
    'workout.save': 'Save',
    'workout.cancel': 'Cancel',
    'workout.deleteConfirm': 'Are you sure you want to delete this set?',
    'workout.deleteConfirmTitle': 'Delete Workout Set',
    'workout.deleteConfirmMessage': 'Are you sure you want to delete this workout set?',
    'workout.analyze': 'AI Workout Analysis',
    'workout.analyzeDescription': 'Get AI-powered insights about your workouts',
    'workout.analyzing': 'Analyzing your workouts...',
    'workout.commentPlaceholder': 'Add a comment (optional)',
    'workout.loading': 'Loading workouts...',
    'workout.noWorkouts': 'No workouts recorded for this date.',
    'workout.add': 'Add Set',
    'workout.details': 'Workout Details',
    'workout.detailNumber': 'Detail #{number}',
    'workout.remove': 'Remove',
    'workout.addDetail': 'Add Detail',
    'workout.noDetails': 'No details available.',
    'workout.advanced': 'Advanced Options',
    'workout.restTime': 'Rest Time (seconds)',
    'workout.restTimePlaceholder': 'Rest time in seconds',
    'workout.restTimeHelper': 'Rest time before this set in seconds',
    'workout.rir': 'RIR/RPE',
    'workout.rirHelper': 'Reps in Reserve or Rate of Perceived Exertion (0-10)',
    'workout.share': 'Share',
    'workout.shareTitle': 'My Workout',
    'workout.workoutsFor': 'Workouts for',
    'workout.amrapTime': 'AMRAP Time',

    // Workout Types
    'workout.workoutType': 'Workout Type',
    'workout.traditionalType': 'Traditional (Sets & Reps)',
    'workout.amrapType': 'AMRAP (As Many Rounds/Reps As Possible)',
    'workout.time': 'Time (minutes)',
    'workout.timePlaceholder': 'e.g., 20',
    'workout.amrapCommentPlaceholder': 'Add notes about your AMRAP workout...',
    'workout.amrapExercises': 'AMRAP Exercises',
    'workout.totalReps': 'Total Reps',
    'workout.addExercise': 'Add Exercise',
    'workout.exerciseNumber': 'Exercise',
    'workout.repsUnit': 'reps',
    'workout.noExercisesRecorded': 'No exercises recorded',
    'workout.exerciseSingular': 'exercise',
    'workout.exercisePlural': 'exercises',

    // Workout validation messages
    'workout.validation.title': 'Please fix the following errors',
    'workout.validation.exerciseRequired': 'Exercise selection is required',
    'workout.validation.seriesRequired': 'Series must be a positive number',
    'workout.validation.repsRequired': 'Reps must be a positive number',
    'workout.validation.weightRequired': 'Weight must be a non-negative number',
    'workout.validation.restTimeInvalid': 'Rest time must be a non-negative number',
    'workout.validation.rirInvalid': 'RIR/RPE must be a number between 0 and 10',

    // Timer
    'timer.running': 'Running',
    'timer.paused': 'Paused',
    'timer.stopped': 'Stopped',
    'timer.finished': 'Finished',
    'timer.pause': 'Pause',
    'timer.resume': 'Resume',
    'timer.reset': 'Reset',
    'timer.stop': 'Stop',
    'timer.restart': 'Restart',
    'timer.configure': 'Configure Timer',
    'timer.quickTimes': 'Quick Times',
    'timer.customTime': 'Custom Time',
    'timer.minutes': 'Minutes',
    'timer.seconds': 'Seconds',
    'timer.cancel': 'Cancel',
    'timer.setTime': 'Set Time',
    'timer.startTimer': 'Start Timer',
    'timer.notificationTitle': 'Timer Finished!',
    'timer.notificationBody': 'Your rest time is up!',

    // Exercise List
    'exercise.add': 'Add Exercise',
    'exercise.name': 'Exercise Name',
    'exercise.delete': 'Delete Exercise',
    'exercise.deleteConfirm': 'Are you sure you want to delete this exercise? All associated workout sets will be deleted.',
    'exercise.deleteConfirmTitle': 'Delete Exercise',
    'exercise.edit': 'Edit Exercise',
    'exercise.lastTrained': 'Last Trained',
    'exercise.maxWeight': 'Max Weight',
    'exercise.cancel': 'Cancel',
    'exercise.confirmCreate': 'Create New Exercise',
    'exercise.confirmCreateMessage': 'Do you want to create a new exercise called "{name}"?',
    'exercise.create': 'Create',
    'exercise.addOption': 'Add "{name}"',

    // Body Weight
    'bodyweight.title': 'Body Weight Progression',
    'bodyweight.enter': 'Enter Body Weight',
    'bodyweight.noData': 'No body weight data available.',
    'bodyweight.log': 'Log Weight',
    'bodyweight.weight': 'Weight (kg)',
    'bodyweight.fatPercentage': 'Fat Percentage (%)',
    'bodyweight.waistCircumference': 'Waist Circumference (cm)',
    'bodyweight.saving': 'Saving...',
    'bodyweight.save': 'Save',
    'bodyweight.updateButton': 'Update Weight',
    'bodyweight.logButton': 'Log Weight',
    'bodyweight.updateTitle': 'Update Body Weight',
    'bodyweight.logTitle': 'Log Body Weight',

    // Analysis
    'analysis.title': 'Workout Analysis',
    'analysis.dateRange': 'Select Date Range',
    'analysis.startDate': 'Start Date',
    'analysis.endDate': 'End Date',
    'analysis.trainingGoal': 'Training Goal',
    'analysis.optional': 'Optional',
    'analysis.trainingGoalPlaceholder': 'e.g., Increase bench press strength, improve endurance, etc.',
    'analysis.analyze': 'Analyze',
    'analysis.close': 'Close',
    'analysis.loading': 'Analyzing workouts...',
    'analysis.validateGoal': 'Validate Goal',
    'analysis.validatingGoal': 'Validating goal...',
    'analysis.goalValid': 'Goal is valid!',
    'analysis.goalInvalid': 'Please improve your goal',
    'analysis.goalValidationError': 'Failed to validate goal. Please try again.',
    'analysis.validationRequired': 'Goal validation required before analysis',
    'analysis.goalNotValidated': 'Please validate your goal before analysis, or remove it to proceed without a goal.',
    'analysis.noGoalInfo': 'You can analyze your workouts without a specific goal, or add a goal above for more targeted analysis.',
    'analysis.dateRangeMode': 'Date Range',
    'analysis.preset': 'Preset',
    'analysis.custom': 'Custom',
    'analysis.presetRange': 'Select Preset Range',
    'analysis.thisWeek': 'This week (from last Monday)',
    'analysis.last7Days': 'Last 7 days',
    'analysis.thisMonth': 'This month',
    'analysis.last30Days': 'Last 30 days',
    'analysis.goalType': 'Analysis Goal',
    'analysis.selectGoalType': 'What would you like to analyze?',
    'analysis.goalMuscleGroups': 'Muscular groups trained during this period',
    'analysis.goalStrength': 'Progress on strength',
    'analysis.goalVolume': 'Volume analysis',
    'analysis.goalFrequency': 'Training frequency by muscle group',
    'analysis.goalRecovery': 'Recovery patterns',
    'analysis.goalCustom': 'Custom goal',
    'analysis.customGoalPlaceholder': 'Describe your specific analysis goal...',
    'analysis.aiDisclaimer': 'AI-Generated Content: This analysis is generated by artificial intelligence and should be used for informational purposes only. Always consult with a qualified fitness professional or healthcare provider before making significant changes to your training program.',

    // Recommendation
    'recommendation.title': 'Workout Recommendation',
    'recommendation.button': 'Get Workout Recommendation',
    'recommendation.generateButton': 'Generate Workout',
    'recommendation.loading': 'Getting AI recommendation...',
    'recommendation.noHistory': 'No workout history found. Start with basic exercises.',
    'recommendation.error': 'Failed to get workout recommendation',
    'recommendation.forDate': 'Recommended workout for {date}',
    'recommendation.exercise': 'Exercise',
    'recommendation.sets': 'Sets',
    'recommendation.reps': 'Reps',
    'recommendation.notes': 'Notes',
    'recommendation.close': 'Close',
    'recommendation.tryWorkout': 'Try This Workout',
    'recommendation.select': 'Select',
    'recommendation.selectAll': 'Select All',
    'recommendation.selectedCount': '{count} of {total} selected',
    'recommendation.importSelected': 'Import Selected',
    'recommendation.importing': 'Importing...',
    'recommendation.importSuccess': 'Successfully imported {count} of {total} {total, plural, one {exercise} other {exercises}}',
    'recommendation.importError': 'Failed to import exercises',
    'recommendation.importPartialError': 'Some exercises failed to import: {failed}',
    'recommendation.importNote': 'Selected exercises will be imported with sets and reps as shown. Weights will be set to 0 for you to fill.',
    'recommendation.description': 'Workout Description',
    'recommendation.descriptionPlaceholder': 'Describe what kind of workout you want (e.g., "upper body strength", "cardio and core", "leg day with squats")...',
    'recommendation.descriptionHelper': 'Optional: Describe your workout preferences to get more targeted recommendations.',
    'recommendation.generateNew': 'Generate New',
    'recommendation.showAlternatives': 'Show Alternatives',

    // Summary View
    'summary.title': 'Exercise Summary',
    'summary.exercise': 'Exercise',
    'summary.lastTrained': 'Last Trained',
    'summary.maxWeight': 'Max Weight (kg)',
    'summary.prDate': 'PR Date',
    'summary.prDetails': 'PR Details',
    'summary.loading': 'Loading summary...',
    'summary.error': 'Failed to fetch exercise summaries',

    // Workout Statistics
    'workoutStats.title': 'Workout Statistics',
    'workoutStats.thisWeek': 'This Week',
    'workoutStats.thisMonth': 'This Month',
    'workoutStats.last7Days': 'Last 7 Days',
    'workoutStats.last30Days': 'Last 30 Days',
    'workoutStats.error': 'Failed to load workout statistics',

    // Exercise List View
    'exercise.title': 'Manage Exercises',
    'exercise.addButton': 'Add',
    'exercise.actions': 'Actions',
    'exercise.exists': 'Exercise already exists',
    'exercise.addError': 'Failed to add exercise',
    'exercise.updateError': 'Failed to update exercise',
    'exercise.deleteError': 'Failed to delete exercise',
    'exercise.deleteUsedError': 'Cannot delete exercise that is used in workouts. Please remove it from all workouts first.',
    'exercise.loading': 'Loading exercises...',
    'exercise.noExercises': 'No exercises available. Add your first exercise!',
    'exercise.save': 'Save',
    'exercise.manageCategories': 'Manage Categories',
    'exercise.close': 'Close',
    'exercise.uncategorized': 'Uncategorized',
    'exercise.category': 'Category',
    'exercise.editTitle': 'Edit Exercise',
    'exercise.addNew': 'Add New Exercise',
    'exercise.adding': 'Adding...',
    'exercise.saving': 'Saving...',
    'exercise.validation.nameRequired': 'Exercise name is required',
    'exercise.validation.categoryRequired': 'Category selection is required',

    // Body Weight View
    'bodyweight.progression': 'Body Weight Progression',
    'bodyweight.fatProgression': 'Fat Percentage Progression',
    'bodyweight.fatMass': 'Fat Mass (kg)',
    'bodyweight.fatMassProgression': 'Fat Mass Progression',
    'bodyweight.bmiProgression': 'BMI Progression',
    'bodyweight.bmi': 'BMI',
    'bodyweight.loading': 'Loading body weight data...',
    'bodyweight.error': 'Failed to fetch body weight logs',

    // Profile
    'profile.title': 'User Profile',
    'profile.email': 'Email',
    'profile.birthDate': 'Birth Date',
    'profile.height': 'Height (cm)',
    'profile.gender': 'Gender',
    'profile.gender.male': 'Male',
    'profile.gender.female': 'Female',
    'profile.gender.other': 'Other',
    'profile.save': 'Save Changes',
    'profile.saving': 'Saving...',
    'profile.error': 'Failed to update profile',
    'profile.success': 'Profile updated successfully',
    'profile.language': 'Language',
    'profile.goals': 'Goals',
    'profile.notes': 'Notes',

    // Profile Setup
    'profileSetup.title': 'Welcome to Lift IQ!',
    'profileSetup.subtitle': 'Let\'s set up your profile to get started',
    'profileSetup.step1.title': 'Birth Date',
    'profileSetup.step1.description': 'When were you born? This helps us calculate age-related fitness metrics.',
    'profileSetup.step2.title': 'Height',
    'profileSetup.step2.description': 'What\'s your height? This helps us provide better workout recommendations.',
    'profileSetup.step3.title': 'Gender',
    'profileSetup.step3.description': 'This information helps us personalize your fitness experience.',
    'profileSetup.next': 'Next',
    'profileSetup.back': 'Back',
    'profileSetup.skip': 'Skip for now',
    'profileSetup.complete': 'Complete Setup',
    'profileSetup.error': 'Failed to complete profile setup. Please try again.',
    'profileSetup.success.title': 'Profile Setup Complete!',
    'profileSetup.success.message': 'Welcome to Lift IQ! You\'re all set to start your fitness journey.',

    // Service Unavailable
    'serviceUnavailable.title': 'Service Starting Up',
    'serviceUnavailable.message': 'Our backend service is waking up (this can take up to 1 minute on free hosting). Please wait a moment and try again.',
    'serviceUnavailable.retryButton': 'Retry Connection',
    'serviceUnavailable.autoRetry': 'Auto-retry in {seconds} seconds...',
    'serviceUnavailable.disableAutoRetry': 'Disable Auto-retry',

    // Clone Workouts
    'cloneWorkouts.title': 'Clone Workouts',
    'cloneWorkouts.button': 'Clone Workouts',
    'cloneWorkouts.selectDate': 'Select source date to clone workouts from:',
    'cloneWorkouts.sourceDate': 'Source Date',
    'cloneWorkouts.workoutsPreview': 'Workouts to be cloned:',
    'cloneWorkouts.noWorkouts': 'No workouts found for selected date',
    'cloneWorkouts.smartButton': 'Clone from last {day}',

    // Import Routine
    'importRoutine.title': 'Import from Routine',
    'importRoutine.button': 'Import from Routine',
    'importRoutine.selectRoutine': 'Select Routine',
    'importRoutine.selectDay': 'Select Day',
    'importRoutine.preview': 'Exercises to Import',
    'importRoutine.allExercisesNote': 'All exercises from this routine day will be imported with their sets and reps. Weights will be left empty for you to fill.',
    'importRoutine.import': 'Import',
    'importRoutine.importing': 'Importing...',
    'importRoutine.noActiveRoutines': 'No active routines available. Create an active routine first.',
    'importRoutine.loadError': 'Failed to load routines',
    'importRoutine.importError': 'Failed to import from routine',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.exportData': 'Export Data',
    'common.exporting': 'Exporting...',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.create': 'Create',
    'common.update': 'Update',
    'common.name': 'Name',
    'common.description': 'Description',
    'common.notes': 'Notes',
    'common.actions': 'Actions',
    'common.loading': 'Loading...',
    'common.noData': 'No data available',
    'common.sharing': 'Sharing...',

    // Routines
    'routines.title': 'Workout Routines',
    'routines.createRoutine': 'Create Routine',
    'routines.importFromWorkout': 'Import from Workout',
    'routines.editRoutine': 'Edit Routine',
    'routines.deleteRoutine': 'Delete Routine',
    'routines.deleteConfirm': 'Are you sure you want to delete this routine? This action cannot be undone.',
    'routines.routineName': 'Routine Name',
    'routines.routineDescription': 'Description',
    'routines.isActive': 'Active',
    'routines.createdAt': 'Created',
    'routines.days': 'Days',
    'routines.exercises': 'Exercises',
    'routines.noDays': 'No days configured',
    'routines.noExercises': 'No exercises configured',
    'routines.addDay': 'Add Day',
    'routines.editDay': 'Edit Day',
    'routines.deleteDay': 'Delete Day',
    'routines.dayNumber': 'Day',
    'routines.dayName': 'Day Name',
    'routines.dayNotes': 'Day Notes',
    'routines.addExercise': 'Add Exercise',
    'routines.removeExercise': 'Remove Exercise',
    'routines.exerciseOrder': 'Order',
    'routines.exerciseNotes': 'Exercise Notes',
    'routines.sets': 'Sets',
    'routines.reps': 'Reps',
    'routines.addSetConfig': 'Add Set Configuration',
    'routines.removeSetConfig': 'Remove Set Configuration',
    'routines.setOrder': 'Set Order',
    'routines.setNotes': 'Set Notes',
    'routines.noRoutines': 'No routines available. Create your first routine!',
    'routines.deleteSuccess': 'Routine deleted successfully',
    'routines.saveSuccess': 'Routine saved successfully',
    'routines.loadError': 'Failed to load routines',
    'routines.saveError': 'Failed to save routine',
    'routines.deleteError': 'Failed to delete routine',
    'routines.selectExercise': 'Select Exercise',
    'routines.dayNamePlaceholder': 'e.g., Push Day, Pull Day, Legs',
    'routines.dayNotesPlaceholder': 'Optional notes for this day',
    'routines.exerciseNotesPlaceholder': 'Optional notes for this exercise',
    'routines.setNotesPlaceholder': 'Optional notes for this set configuration',
    'routines.repsPlaceholder': 'e.g., 10 or 8-12',

    // Routine Sharing
    'routines.shareRoutine': 'Share Routine',
    'routines.share': 'Share',
    'routines.shareSuccess': 'Routine shared successfully',
    'routines.shareError': 'Failed to share routine',
    'routines.sharePartialSuccess': 'Shared with {successful} of {total} friends',
    'routines.selectFriends': 'Select Friends to Share With',
    'routines.selectAll': 'Select All',
    'routines.shareMessage': 'Optional Message',
    'routines.shareMessagePlaceholder': 'Add a personal message with your routine...',
    'routines.noFriendsToShare': 'You need friends to share routines. Add friends first!',
    'routines.routineStats': '{days} days, {exercises} exercises',
    'routines.myRoutines': 'My Routines',
    'routines.sharedRoutines': 'Shared Routines',
    'routines.received': 'Received',
    'routines.sent': 'Sent',
    'routines.receivedShares': 'Routines Shared With You',
    'routines.sentShares': 'Routines You\'ve Shared',
    'routines.noReceivedShares': 'No routines have been shared with you yet.',
    'routines.noSentShares': 'You haven\'t shared any routines yet.',
    'routines.preview': 'Preview',
    'routines.accept': 'Accept',
    'routines.decline': 'Decline',
    'routines.acceptRoutine': 'Accept Routine',
    'routines.acceptError': 'Failed to accept routine',
    'routines.declineError': 'Failed to decline routine',
    'routines.loadSharedError': 'Failed to load shared routines',
    'routines.sharedBy': 'Shared by',
    'routines.sharedWith': 'Shared with',
    'routines.message': 'Message',
    'routines.previewRoutine': 'Routine Preview',
    'routines.workoutDays': 'Workout Days',
    'routines.day': 'Day',
    'routines.inactive': 'Inactive',
    'routines.pending': 'Pending',
    'routines.accepted': 'Accepted',
    'routines.declined': 'Declined',
    'routines.acceptInfo': 'Accepting this routine will create a copy in your routines. Any exercises not in your library will be created automatically.',
    'routines.confirmAccept': 'Accept Routine?',
    'routines.confirmDecline': 'Decline Routine?',
    'routines.confirmAcceptMessage': 'Are you sure you want to accept the routine "{name}"? It will be added to your routines.',
    'routines.confirmDeclineMessage': 'Are you sure you want to decline the routine "{name}"?',
    'routines.cancelShare': 'Cancel Share',
    'routines.routineShared': 'Routine shared successfully!',

    // Training Programs
    'programs.title': 'Training Programs',
    'programs.browse': 'Browse Programs',
    'programs.enroll': 'Enroll',
    'programs.enrolledSince': 'Enrolled since',
    'programs.sessionsCompleted': 'Sessions completed',
    'programs.status.active': 'Active',
    'programs.status.paused': 'Paused',
    'programs.status.completed': 'Completed',
    'programs.nextWorkout': 'Next Workout',
    'programs.startWeights': 'Starting Weights',
    'programs.startingWorkout': 'Starting Workout',
    'programs.currentWeight': 'Current Weight',
    'programs.increment': 'Increment',
    'programs.deload': 'Deload',
    'programs.deloadWarning': 'Deload imminent — 1 more failure will trigger a 10% weight reduction',
    'programs.logSession': 'Log Session',
    'programs.sessionLogged': 'Session logged successfully',
    'programs.progressChart': 'Progress Chart',
    'programs.sessionHistory': 'Session History',
    'programs.leave': 'Leave Program',
    'programs.pause': 'Pause',
    'programs.resume': 'Resume',
    'programs.frequency': '{n} days / week',
    'programs.workoutA': 'Workout A',
    'programs.workoutB': 'Workout B',
    'programs.sets': 'Sets',
    'programs.reps': 'Reps',
    'programs.succeeded': 'Succeeded',
    'programs.failed': 'Failed',
    'programs.noEnrollment': 'You are not enrolled in any program yet.',
    'programs.enrollConfirm': 'Enroll in {name}',
    'programs.leaveConfirm': 'Are you sure you want to leave this program? All your progress will be lost.',
    'programs.leaveConfirmTitle': 'Leave Program?',
    'programs.startWeight': 'Starting Weight (kg)',
    'programs.exercises': 'Exercises',
    'programs.workoutsPerWeek': 'workouts / week',
    'programs.consecutiveFailures': '{n} failure(s) — deload after 3',
    'programs.noSessions': 'No sessions logged yet.',
    'programs.noProgress': 'No progression data yet.',
    'programs.date': 'Date',
    'programs.notesOptional': 'Notes (optional)',
    'programs.defaultWeightHint': 'Leave blank to use program defaults',
    'programs.calendarSession': 'Program Session',
    'programs.noDetailRecorded': 'Detailed results not recorded',
    'programs.deleteSession': 'Delete Session',
    'programs.deleteSessionConfirm': 'Are you sure? This will reverse the progression applied by this session.',
    'programs.editSession': 'Edit Session',
    'programs.editWeights': 'Edit Starting Weights',
    'programs.sessionDeleted': 'Session deleted and progression reversed',
    'programs.sessionUpdated': 'Session updated successfully',
    'programs.weightsUpdated': 'Starting weights updated',
    'programs.cannotEditWeights': 'Weights can only be edited before your first session',
    'programs.startWorkout': 'Start Workout',
    'programs.resumeWorkout': 'Resume Workout',
    'programs.finishWorkout': 'Finish Workout',
    'programs.abandonWorkout': 'Abandon Workout',
    'programs.abandonConfirm': 'Abandon this workout? Your progress will be lost.',
    'programs.workoutInProgress': 'Workout in progress',
    'programs.markDone': 'Mark Done',
    'programs.setsDone': '{done} of {total} sets done',
    'programs.finishIncomplete': 'You have {remaining} sets remaining. Finish anyway?',
    'programs.logManual': 'Log Session (manual)',
    'programs.startedAt': 'Started',

    // Friends
    'friends.title': 'Friends',
    'friends.yourFriends': 'Your Friends',
    'friends.noFriendsMessage': 'You don\'t have any friends yet. Use the "Add Friends" tab to find and add friends!',
    'friends.friendRequests': 'Friend Requests',
    'friends.receivedRequests': 'Received Requests',
    'friends.sentRequests': 'Sent Requests',
    'friends.noPendingRequests': 'No pending friend requests.',
    'friends.findFriends': 'Find Friends',
    'friends.searchByEmail': 'Search by email',
    'friends.search': 'Search',
    'friends.searchResults': 'Search Results',
    'friends.noUsersFound': 'No users found with that email address.',
    'friends.friendsTab': 'Friends ({count})',
    'friends.requestsTab': 'Requests ({count})',
    'friends.addFriendsTab': 'Add Friends',
    'friends.addFriend': 'Add Friend',
    'friends.statusFriends': 'Friends',
    'friends.statusRequestSent': 'Request Sent',
    'friends.statusRequestReceived': 'Request Received',
    'friends.statusDeclined': 'Declined',
    'friends.statusBlocked': 'Blocked',
    'friends.statusPending': 'Pending',
    'friends.loadError': 'Failed to load friends',
    'friends.searchError': 'Failed to search users',
    'friends.sendRequestError': 'Failed to send friend request',
    'friends.acceptRequestError': 'Failed to accept friend request',
    'friends.declineRequestError': 'Failed to decline friend request',
    'friends.removeError': 'Failed to remove friend',
    'friends.confirmRemoveTitle': 'Confirm Friend Removal',
    'friends.confirmRemoveMessage': 'Are you sure you want to remove {friendName} from your friends list?',
    'friends.remove': 'Remove',

    // Workout Sharing
    'workoutShare.title': 'Share Workout',
    'workoutShare.selectFriend': 'Select Friend',
    'workoutShare.selectExercises': 'Select Exercises',
    'workoutShare.exerciseName': 'Exercise Name',
    'workoutShare.sets': 'Sets',
    'workoutShare.reps': 'Reps',
    'workoutShare.addExercise': 'Add Exercise',
    'workoutShare.removeExercise': 'Remove',
    'workoutShare.message': 'Optional Message',
    'workoutShare.messagePlaceholder': 'Add a personal message with your workout...',
    'workoutShare.share': 'Share Workout',
    'workoutShare.cancel': 'Cancel',
    'workoutShare.shareSuccess': 'Workout shared successfully',
    'workoutShare.shareError': 'Failed to share workout',
    'workoutShare.noFriendsToShare': 'You need friends to share workouts. Add friends first!',
    'workoutShare.atLeastOneExercise': 'Add at least one exercise to share',
    'workoutShare.sharedWorkouts': 'Shared Workouts',
    'workoutShare.receivedShares': 'Workouts Shared With You',
    'workoutShare.sentShares': 'Workouts You\'ve Shared',
    'workoutShare.noReceivedShares': 'No workouts have been shared with you yet.',
    'workoutShare.noSentShares': 'You haven\'t shared any workouts yet.',
    'workoutShare.preview': 'Preview',
    'workoutShare.accept': 'Accept',
    'workoutShare.decline': 'Decline',
    'workoutShare.acceptWorkout': 'Accept Workout',
    'workoutShare.acceptError': 'Failed to accept workout',
    'workoutShare.declineError': 'Failed to decline workout',
    'workoutShare.loadSharedError': 'Failed to load shared workouts',
    'workoutShare.sharedBy': 'Shared by',
    'workoutShare.sharedWith': 'Shared with',
    'workoutShare.exercises': 'Exercises',
    'workoutShare.previewWorkout': 'Workout Preview',
    'workoutShare.selectDate': 'Select Date to Import',
    'workoutShare.targetDate': 'Import to Date',
    'workoutShare.acceptInfo': 'Accepting this workout will import the exercises to your selected date. Any exercises not in your library will be created automatically.',
    'workoutShare.confirmAccept': 'Accept Workout?',
    'workoutShare.confirmDecline': 'Decline Workout?',
    'workoutShare.confirmAcceptMessage': 'Are you sure you want to accept this workout? It will be imported to your selected date.',
    'workoutShare.confirmDeclineMessage': 'Are you sure you want to decline this workout?',
    'workoutShare.acceptSuccess': 'Workout accepted and imported successfully',
    'workoutShare.declineSuccess': 'Workout declined',
    'workoutShare.pending': 'Pending',
    'workoutShare.accepted': 'Accepted',
    'workoutShare.declined': 'Declined',
    'workoutShare.fillAllFields': 'Please fill in all exercise fields',
    'workoutShare.exerciseOrder': 'Exercise {order}',

    // Notifications
    'notifications.title': 'Notifications',
    'notifications.noNotifications': 'No new notifications',
    'notifications.friendRequest': 'Friend Request',
    'notifications.friendRequestAccepted': 'Friend Request Accepted',
    'notifications.routineShare': 'Routine Shared',
    'notifications.routineShareAccepted': 'Routine Share Accepted',
    'notifications.workoutShare': 'Workout Shared',
    'notifications.workoutShareAccepted': 'Workout Share Accepted',
    'notifications.friendRequestFrom': '{name} sent you a friend request',
    'notifications.friendRequestAcceptedFrom': '{name} accepted your friend request',
    'notifications.routineShareFrom': '{name} shared a routine with you',
    'notifications.routineShareAcceptedFrom': '{name} accepted your shared routine "{routineName}"',
    'notifications.workoutShareFrom': '{name} shared a workout with you',
    'notifications.workoutShareAcceptedFrom': '{name} accepted your shared workout',
    'notifications.viewFriends': 'View Friends',
    'notifications.viewSharedRoutines': 'View Shared Routines',
    'notifications.markAllRead': 'Mark All Read',
    'notifications.clearAll': 'Clear All Notifications',
    'notifications.error': 'Failed to load notifications',

    // Import Workout
    'importWorkout.title': 'Import Workout to Routine',
    'importWorkout.selectRoutine': 'Select Routine',
    'importWorkout.selectDate': 'Select Workout Date',
    'importWorkout.dayName': 'Day Name',
    'importWorkout.dayNamePlaceholder': 'e.g., Push Day, Pull Day',
    'importWorkout.dayNotes': 'Day Notes',
    'importWorkout.dayNotesPlaceholder': 'Optional notes for this routine day',
    'importWorkout.workoutPreview': 'Workout Preview',
    'importWorkout.exercisesToImport': 'Exercises to import',
    'importWorkout.sets': 'sets',
    'importWorkout.importNote': 'Sets and reps will be converted to routine format as target values',
    'importWorkout.noWorkoutsFound': 'No workouts found for this date',
    'importWorkout.previewError': 'Failed to load workout preview',
    'importWorkout.importError': 'Failed to import workout to routine',
    'importWorkout.importSuccess': 'Workout imported to routine successfully',
    'importWorkout.import': 'Import',
    'importWorkout.importing': 'Importing...',

    // Release Notes
    'releaseNotes.title': 'What\'s New',
    'releaseNotes.new': 'New',
    'releaseNotes.fix': 'Fix',
    'releaseNotes.improvement': 'Improvement',

    // Recent Workouts
    'recentWorkouts.title': 'Recent Workouts for {exerciseName}',
    'recentWorkouts.noData': 'No recent workouts found for this exercise.',
    'recentWorkouts.set': 'Set {series}: {reps} reps at {weight} kg',

    // Chat
    'chat.title': 'Fitness Assistant',
    'chat.placeholder': 'Ask a question about your workouts...',
    'chat.send': 'Send',
    'chat.voice.start': 'Voice',
    'chat.voice.stop': 'Stop',
    'chat.voice.unsupported': 'Voice input not supported in this browser',
    'chat.listening': 'Listening…',
    'chat.voice.lang': 'en-US',

    // Evaluation
    'evaluation.title': 'AI Analysis Evaluation System',
    'evaluation.description': 'Test and validate AI workout analysis responses using multiple models and comprehensive evaluation criteria.',
    'evaluation.devWarning': '⚠️ Developer Tool: This evaluation system is for testing and development purposes only.',
    'evaluation.tabs.runEvaluation': 'Run Evaluation',
    'evaluation.tabs.testCases': 'Test Cases',
    'evaluation.tabs.resultsHistory': 'Results History',

    // Evaluation Runner
    'evaluation.runner.title': 'Configure Evaluation',
    'evaluation.runner.selectTestCase': 'Load Test Case (Optional)',
    'evaluation.runner.testCaseHelper': 'Select a test case to auto-populate the form',
    'evaluation.runner.noTestCase': 'None - Manual Entry',
    'evaluation.runner.selectUser': 'Select User',
    'evaluation.runner.startDate': 'Start Date',
    'evaluation.runner.endDate': 'End Date',
    'evaluation.runner.goal': 'Analysis Goal',
    'evaluation.runner.goalHelp': 'Optional: Specify what to analyze (e.g., "muscle groups", "strength progress")',
    'evaluation.runner.language': 'Language',
    'evaluation.runner.modelSelection': 'Model Selection',
    'evaluation.runner.both': 'Compare Both',
    'evaluation.runner.run': 'Run Evaluation',
    'evaluation.runner.running': 'Running...',
    'evaluation.runner.requiredFields': 'Please fill in all required fields',
    'evaluation.runner.error': 'Failed to run evaluation. Please try again.',

    // Test Cases
    'evaluation.testCases.title': 'Test Cases',
    'evaluation.testCases.create': 'Create Test Case',
    'evaluation.testCases.empty': 'No test cases yet. Create one to get started.',
    'evaluation.testCases.goal': 'Goal',
    'evaluation.testCases.requiredFields': 'Please fill in all required fields',
    'evaluation.testCases.createError': 'Failed to create test case',
    'evaluation.testCases.createDialog.title': 'Create Test Case',
    'evaluation.testCases.createDialog.name': 'Name',
    'evaluation.testCases.createDialog.description': 'Description',
    'evaluation.testCases.createDialog.user': 'User',
    'evaluation.testCases.createDialog.startDate': 'Start Date',
    'evaluation.testCases.createDialog.endDate': 'End Date',
    'evaluation.testCases.createDialog.goalType': 'Goal Type',
    'evaluation.testCases.createDialog.goalTypeHelp': 'Select predefined analysis goal or choose custom',
    'evaluation.testCases.createDialog.customGoal': 'Custom Goal',
    'evaluation.testCases.createDialog.language': 'Language',
    'evaluation.testCases.createDialog.expectedTopics': 'Expected Topics',
    'evaluation.testCases.createDialog.expectedTopicsHelp': 'Comma-separated list of topics that should be covered (auto-filled for predefined goals)',

    // Results History
    'evaluation.history.title': 'Evaluation Results History',
    'evaluation.history.empty': 'No evaluation runs yet. Run an evaluation to see results here.',
    'evaluation.history.loading': 'Loading results...',
    'evaluation.history.loadError': 'Failed to load results',
    'evaluation.history.runInfo': 'Run Info',
    'evaluation.history.testCase': 'Test Case',
    'evaluation.history.dateRange': 'Date Range',
    'evaluation.history.runDate': 'Run Date',
    'evaluation.history.view': 'View Details',
    'evaluation.history.delete': 'Delete',
    'evaluation.history.confirmDelete': 'Are you sure you want to delete this evaluation run?',

    // Results
    'evaluation.results.title': 'Evaluation Results',
    'evaluation.results.exportJson': 'Export JSON',
    'evaluation.results.exportCsv': 'Export CSV',
    'evaluation.results.comparisonSummary': 'Model Comparison',
    'evaluation.results.responses': 'AI Responses',
    'evaluation.results.viewResponse': 'View Full Response',

    // Criteria
    'evaluation.criteria.relevance': 'Relevance',
    'evaluation.criteria.dataUtilization': 'Data Utilization',
    'evaluation.criteria.accuracy': 'Accuracy',
    'evaluation.criteria.specificity': 'Specificity',
    'evaluation.criteria.languageConsistency': 'Language Consistency',
    'evaluation.criteria.format': 'Format',
    'evaluation.criteria.completeness': 'Completeness',
    'evaluation.criteria.safety': 'Safety',
    'evaluation.criteria.score': 'Score',
    'evaluation.criteria.viewDetails': 'View Details',
    'evaluation.criteria.reasoning': 'Detailed Reasoning',

    // Wrapped 2025
    'wrapped.title': '2025 LIFT IQ WRAPPED',
    'wrapped.subtitle': 'Your Year of Gains',
    'wrapped.totalWorkouts': 'Total Workouts',
    'wrapped.tonnesLifted': 'Tonnes Lifted',
    'wrapped.topExercises': 'Top Exercises',
    'wrapped.consistency': 'Consistency Check',
    'wrapped.greatWork': 'Great work in 2025!',
    'wrapped.keepPushing': 'Keep pushing your limits. See you in the gym.',
    'wrapped.share': 'Share My Stats',
    'wrapped.shareTitle': 'My 2025 Lift IQ Wrapped',
    'wrapped.shareMessage': 'I completed {workouts} workouts and lifted {tonnes} tonnes in 2025! #LiftIQ',
    'wrapped.error': 'Could not load your 2025 Lift IQ Wrapped. Maybe you haven\'t worked out enough yet? 😉',
    'wrapped.noExercises': 'No exercises recorded yet.',
    'wrapped.navTitle': '2025 Wrapped',

    // Months Short
    'monthsShort.jan': 'Jan',
    'monthsShort.feb': 'Feb',
    'monthsShort.mar': 'Mar',
    'monthsShort.apr': 'Apr',
    'monthsShort.may': 'May',
    'monthsShort.jun': 'Jun',
    'monthsShort.jul': 'Jul',
    'monthsShort.aug': 'Aug',
    'monthsShort.sep': 'Sep',
    'monthsShort.oct': 'Oct',
    'monthsShort.nov': 'Nov',
    'monthsShort.dec': 'Dec',

    // AI Workout Wizard
    'aiWizard.steps.location': 'Location',
    'aiWizard.steps.muscles': 'Muscles',
    'aiWizard.steps.type': 'Type',
    'aiWizard.steps.duration': 'Duration',
    'aiWizard.steps.level': 'Level',
    'aiWizard.steps.exercises': 'Exercises',
    'aiWizard.steps.summary': 'Summary',
    'aiWizard.step_counter': 'Step {current} of {total}',
    'aiWizard.muscles.title': 'Select Target Muscle Groups',
    'aiWizard.muscles.subtitle': 'Select none for a Full Body workout',
    'aiWizard.muscles.chest': 'Chest',
    'aiWizard.muscles.back': 'Back',
    'aiWizard.muscles.shoulders': 'Shoulders',
    'aiWizard.muscles.abs': 'Abs',
    'aiWizard.muscles.quadriceps': 'Quadriceps',
    'aiWizard.muscles.hamstrings': 'Hamstrings',
    'aiWizard.muscles.glutes': 'Glutes',
    'aiWizard.muscles.calves': 'Calves',
    'aiWizard.muscles.adductors': 'Adductors',
    'aiWizard.muscles.biceps': 'Biceps',
    'aiWizard.muscles.triceps': 'Triceps',
    'aiWizard.muscles.cardio': 'Cardio/Running',
    'aiWizard.muscles.swimming': 'Swimming',
    'aiWizard.duration.minutes': 'Time (Minutes)',
    'aiWizard.duration.exercises': 'Exercise Count',
    'aiWizard.duration.targetTime': 'Target Time: {value} minutes',
    'aiWizard.duration.targetCount': 'Target: {value} exercises',
    'review.title': 'Review your Workout',
    'review.overview.subtitle': 'Here is the proposed plan. Let\'s review it exercise by exercise.',
    'review.step.sets': 'Sets',
    'review.step.reps': 'Reps',
    'review.step.recommended': 'Recommended: {value}',
    'review.step.notes': 'Notes',
    'review.step.swap': 'Swap Exercise',
    'review.step.remove': 'Remove Exercise',
    'review.step.skip': 'Skip Exercise',
    'review.step.skipped': 'Skipped',
    'review.button.start': 'Start Review',
    'review.button.finish': 'Import Workout',
    'review.summary.ready': 'Ready to Train!',
    'review.summary.subtitle': 'Your workout with {count} exercises is ready to be imported.',
    'aiWizard.exercises.title': 'Use Your Exercise Library Only?',
    'aiWizard.exercises.description': 'If enabled, the AI will try to only recommend exercises you have already created. This is good for keeping your history clean, but might limit creativity.',
    'aiWizard.exercises.yes': 'Yes, use my exercises',
    'aiWizard.exercises.no': 'No, allow new exercises',
    'aiWizard.exercises.count': '{count} exercises available in your library.',
    'aiWizard.summary.location': 'Location',
    'aiWizard.summary.muscles': 'Muscles',
    'aiWizard.summary.type': 'Type',
    'aiWizard.summary.target': 'Target',
    'aiWizard.summary.level': 'Level',
    'aiWizard.summary.source': 'Exercise Source',
    'aiWizard.summary.fullBody': 'Full Body',
    'aiWizard.summary.libraryOnly': 'My Library Only',
    'aiWizard.summary.any': 'Any',
    'aiWizard.summary.ready': 'Ready to generate? This might take a few seconds.',
    'aiWizard.button.back': 'Back',
    'aiWizard.button.next': 'Next',
    'aiWizard.button.generate': 'Generate Workout',
    'aiWizard.button.generating': 'Generating...',
    'aiWizard.button.undo': 'Undo',
    'aiWizard.location.home': 'At Home',
    'aiWizard.location.homeDesc': 'Limited equipment, bodyweight focus',
    'aiWizard.location.gym': 'At Gym',
    'aiWizard.location.gymDesc': 'Full equipment access',
    'aiWizard.type.hypertrophy': 'Hypertrophy',
    'aiWizard.type.hypertrophyDesc': 'Focus on muscle growth (8-12 reps)',
    'aiWizard.type.strength': 'Strength',
    'aiWizard.type.strengthDesc': 'Focus on raw power (1-6 reps)',
    'aiWizard.type.resistance': 'Endurance/Resistance',
    'aiWizard.type.resistanceDesc': 'Higher reps, lower rest',
    'aiWizard.level.beginner': 'Beginner',
    'aiWizard.level.beginnerDesc': 'Focus on fundamentals and learning form',
    'aiWizard.level.experienced': 'Experienced',
    'aiWizard.level.experiencedDesc': 'Advanced techniques and higher volume',
    'recommendation.error.generic': 'We could not generate a workout at this time. Please try again later.',
  },
  es: {
    // Global
    'global.of': 'de',
    'global.with': 'con',

    // Share
    'share.intro': '¡Échale un vistazo a mi entrenamiento!',
    'share.outro': 'También puedes usar LiftIQ para registrar tus entrenamientos en https://liftiq.es',

    // Units
    'units.minutes': 'minutos',
    'units.seconds': 'segundos',
    'units.reps': 'repeticiones',
    'units.kg': 'kg',
    'units.lbs': 'lbs',
    'units.cm': 'cm',
    'units.in': 'in',

    // Categories
    'category.title': 'Gestionar Categorías',
    'category.new': 'Nueva Categoría',
    'category.edit': 'Editar Categoría',
    'category.delete': 'Eliminar Categoría',
    'category.name': 'Nombre de la Categoría',
    'category.deleteConfirm': '¿Estás seguro de que quieres eliminar esta categoría? Se eliminará de todos los ejercicios asociados.',
    'category.deleteError': 'No se puede eliminar la categoría que está en uso.',
    'category.addError': 'Error al agregar categoría',
    'category.updateError': 'Error al actualizar categoría',
    'category.cancel': 'Cancelar',
    'category.save': 'Guardar',
    'category.close': 'Cerrar',
    'category.nameRequired': 'El nombre de la categoría es requerido',
    'category.subtitle': 'Categorías',

    // Navigation
    'nav.calendar': 'Calendario',
    'nav.summary': 'Resumen',
    'nav.exercises': 'Ejercicios',
    'nav.bodyweight': 'Peso Corporal',
    'nav.routines': 'Rutinas',
    'nav.programs': 'Programas',
    'nav.friends': 'Amigos',
    'nav.chat': 'Chat',
    'nav.evaluation': 'Evaluaciones',
    'nav.profile': 'Perfil',
    'nav.releaseNotes': 'Notas de Lanzamiento',
    'nav.logout': 'Cerrar Sesión',
    'nav.appTitle': 'Lift IQ',

    // Logout Dialog
    'logout.title': 'Confirmar Cierre de Sesión',
    'logout.message': '¿Estás seguro de que quieres cerrar sesión? Necesitarás iniciar sesión nuevamente para acceder a tus datos.',
    'logout.cancel': 'Cancelar',
    'logout.confirm': 'Cerrar Sesión',

    // Login
    'login.title': 'Lift IQ',
    'login.subtitle': 'Registra tus entrenamientos y monitorea tu progreso',
    'login.sessionExpired': 'Sesión Expirada',
    'login.sessionExpiredMessage': 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente para continuar.',
    'login.accessDenied': 'Acceso Denegado',
    'login.accessDeniedMessage': 'No estás autorizado para usar esta aplicación.',
    'login.googleError': 'Error al cargar el script de Google Sign-In. Por favor, verifica tu conexión a internet o intenta actualizar la página.',
    'login.signingIn': 'Iniciando sesión...',

    // Calendar
    'calendar.selectDate': 'Selecciona una fecha para registrar tu entrenamiento',
    'calendar.workoutsFor': 'Entrenamientos para',
    'calendar.bodyWeight': 'Peso Corporal',
    'calendar.noBodyWeight': 'No hay registro de peso corporal para esta fecha',
    'calendar.addWorkoutEntryButton': 'Agregar Entrenamiento',
    'calendar.addWorkoutEntry': 'Agregar Entrada de Entrenamiento',
    'calendar.addWorkout': 'Agregar Entrenamiento',
    'calendar.smartActions': 'Acciones Inteligentes',
    'calendar.addWorkoutEntryTitle': 'Agregar Nueva Entrada de Entrenamiento',
    'calendar.editWorkoutEntryTitle': 'Editar Entrada de Entrenamiento',

    // Workout Form
    'workout.exercise': 'Ejercicio',
    'workout.series': 'Series',
    'workout.reps': 'Repeticiones',
    'workout.weight': 'Peso (kg)',
    'workout.comment': 'Comentario',
    'workout.addSet': 'Agregar Series',
    'workout.editSet': 'Editar Serie',
    'workout.edit': 'Editar',
    'workout.delete': 'Eliminar',
    'workout.save': 'Guardar',
    'workout.cancel': 'Cancelar',
    'workout.deleteConfirm': '¿Estás seguro de que quieres eliminar esta serie?',
    'workout.deleteConfirmTitle': 'Eliminar Serie',
    'workout.deleteConfirmMessage': '¿Estás seguro de que quieres eliminar esta serie de entrenamiento?',
    'workout.analyze': 'Análisis IA de Entrenamiento',
    'workout.analyzeDescription': 'Obtén información sobre tus entrenamientos con IA',
    'workout.analyzing': 'Analizando tus entrenamientos...',
    'workout.commentPlaceholder': 'Agrega un comentario (opcional)',
    'workout.loading': 'Cargando entrenamientos...',
    'workout.noWorkouts': 'No hay entrenamientos registrados para esta fecha.',
    'workout.add': 'Agregar Serie',
    'workout.details': 'Detalles del Entrenamiento',
    'workout.detailNumber': 'Detalle #{number}',
    'workout.remove': 'Quitar',
    'workout.addDetail': 'Agregar Detalle',
    'workout.noDetails': 'No hay detalles disponibles.',
    'workout.advanced': 'Opciones Avanzadas',
    'workout.restTime': 'Tiempo de Descanso (segundos)',
    'workout.restTimePlaceholder': 'Tiempo de descanso en segundos',
    'workout.restTimeHelper': 'Tiempo de descanso antes de esta serie en segundos',
    'workout.rir': 'RIR/RPE',
    'workout.rirHelper': 'Repeticiones en Reserva o Tasa de Esfuerzo Percibido (0-10)',
    'workout.share': 'Compartir',
    'workout.shareTitle': 'Mi Entrenamiento',
    'workout.workoutsFor': 'Entrenamientos para',
    'workout.amrapTime': 'Tiempo AMRAP',

    // Workout Types
    'workout.workoutType': 'Tipo de Entrenamiento',
    'workout.traditionalType': 'Tradicional (Series y Repeticiones)',
    'workout.amrapType': 'AMRAP (Tantas Rondas/Repeticiones Como Sea Posible)',
    'workout.time': 'Tiempo (minutos)',
    'workout.timePlaceholder': 'ej., 20',
    'workout.amrapCommentPlaceholder': 'Añadir notas sobre tu entrenamiento AMRAP...',
    'workout.amrapExercises': 'Ejercicios AMRAP',
    'workout.totalReps': 'Repeticiones Totales',
    'workout.addExercise': 'Añadir Ejercicio',
    'workout.exerciseNumber': 'Ejercicio',
    'workout.repsUnit': 'repeticiones',
    'workout.noExercisesRecorded': 'No hay ejercicios registrados',
    'workout.exerciseSingular': 'ejercicio',
    'workout.exercisePlural': 'ejercicios',

    // Workout validation messages
    'workout.validation.title': 'Corrige los siguientes errores',
    'workout.validation.exerciseRequired': 'La selección de ejercicio es requerida',
    'workout.validation.seriesRequired': 'Las series deben ser un número positivo',
    'workout.validation.repsRequired': 'Las repeticiones deben ser un número positivo',
    'workout.validation.weightRequired': 'El peso debe ser un número no negativo',
    'workout.validation.restTimeInvalid': 'El tiempo de descanso debe ser un número no negativo',
    'workout.validation.rirInvalid': 'RIR/RPE debe ser un número entre 0 y 10',

    // Timer
    'timer.running': 'Corriendo',
    'timer.paused': 'Pausado',
    'timer.stopped': 'Detenido',
    'timer.finished': 'Terminado',
    'timer.pause': 'Pausar',
    'timer.resume': 'Reanudar',
    'timer.reset': 'Reiniciar',
    'timer.stop': 'Detener',
    'timer.restart': 'Reiniciar',
    'timer.configure': 'Configurar Temporizador',
    'timer.quickTimes': 'Tiempos Rápidos',
    'timer.customTime': 'Tiempo Personalizado',
    'timer.minutes': 'Minutos',
    'timer.seconds': 'Segundos',
    'timer.cancel': 'Cancelar',
    'timer.setTime': 'Establecer Tiempo',
    'timer.startTimer': 'Iniciar Temporizador',
    'timer.notificationTitle': '¡Temporizador Terminado!',
    'timer.notificationBody': '¡Tu tiempo de descanso ha terminado!',

    // Exercise List
    'exercise.add': 'Agregar Ejercicio',
    'exercise.name': 'Nombre del Ejercicio',
    'exercise.delete': 'Eliminar Ejercicio',
    'exercise.deleteConfirm': '¿Estás seguro de que quieres eliminar este ejercicio? Todas las series asociadas serán eliminadas.',
    'exercise.deleteConfirmTitle': 'Eliminar Ejercicio',
    'exercise.edit': 'Editar Ejercicio',
    'exercise.lastTrained': 'Último Entrenamiento',
    'exercise.maxWeight': 'Peso Máximo',
    'exercise.cancel': 'Cancelar',
    'exercise.confirmCreate': 'Crear Nuevo Ejercicio',
    'exercise.confirmCreateMessage': '¿Quieres crear un nuevo ejercicio llamado "{name}"?',
    'exercise.create': 'Crear',
    'exercise.addOption': 'Agregar "{name}"',

    // Body Weight
    'bodyweight.title': 'Progresión del Peso Corporal',
    'bodyweight.enter': 'Ingresar Peso Corporal',
    'bodyweight.noData': 'No hay datos de peso corporal disponibles.',
    'bodyweight.log': 'Registrar Peso',
    'bodyweight.weight': 'Peso (kg)',
    'bodyweight.fatPercentage': 'Porcentaje de Grasa (%)',
    'bodyweight.waistCircumference': 'Circunferencia de Cintura (cm)',
    'bodyweight.saving': 'Guardando...',
    'bodyweight.save': 'Guardar',
    'bodyweight.updateButton': 'Actualizar Peso',
    'bodyweight.logButton': 'Registrar Peso',
    'bodyweight.updateTitle': 'Actualizar Peso Corporal',
    'bodyweight.logTitle': 'Registrar Peso Corporal',

    // Analysis
    'analysis.title': 'Análisis de Entrenamiento',
    'analysis.dateRange': 'Seleccionar Rango de Fechas',
    'analysis.startDate': 'Fecha de Inicio',
    'analysis.endDate': 'Fecha de Fin',
    'analysis.trainingGoal': 'Objetivo de Entrenamiento',
    'analysis.optional': 'Opcional',
    'analysis.trainingGoalPlaceholder': 'ej., Aumentar la fuerza en press de banca, mejorar la resistencia, etc.',
    'analysis.analyze': 'Analizar',
    'analysis.close': 'Cerrar',
    'analysis.loading': 'Analizando entrenamientos...',
    'analysis.validateGoal': 'Validar Objetivo',
    'analysis.validatingGoal': 'Validando objetivo...',
    'analysis.goalValid': 'Objetivo válido!',
    'analysis.goalInvalid': 'Por favor, mejorar tu objetivo',
    'analysis.goalValidationError': 'Error al validar objetivo. Por favor, inténtalo de nuevo.',
    'analysis.validationRequired': 'Validación de objetivo requerida antes de analizar',
    'analysis.goalNotValidated': 'Por favor, valida tu objetivo antes de analizar, o remuévelo para proceder sin objetivo.',
    'analysis.noGoalInfo': 'Puedes analizar tus entrenamientos sin un objetivo específico, o agrega uno arriba para un análisis más dirigido.',
    'analysis.dateRangeMode': 'Rango de Fechas',
    'analysis.preset': 'Predefinido',
    'analysis.custom': 'Personalizado',
    'analysis.presetRange': 'Seleccionar Rango Predefinido',
    'analysis.thisWeek': 'Esta semana (desde el lunes pasado)',
    'analysis.last7Days': 'Últimos 7 días',
    'analysis.thisMonth': 'Este mes',
    'analysis.last30Days': 'Últimos 30 días',
    'analysis.goalType': 'Objetivo del Análisis',
    'analysis.selectGoalType': '¿Qué te gustaría analizar?',
    'analysis.goalMuscleGroups': 'Grupos musculares entrenados durante este período',
    'analysis.goalStrength': 'Progreso en fuerza',
    'analysis.goalVolume': 'Análisis de volumen',
    'analysis.goalFrequency': 'Frecuencia de entrenamiento por grupo muscular',
    'analysis.goalRecovery': 'Patrones de recuperación',
    'analysis.goalCustom': 'Objetivo personalizado',
    'analysis.customGoalPlaceholder': 'Describe tu objetivo de análisis específico...',
    'analysis.aiDisclaimer': 'Contenido Generado por IA: Este análisis es generado por inteligencia artificial y debe usarse solo con fines informativos. Siempre consulta con un profesional de fitness calificado o proveedor de atención médica antes de realizar cambios significativos en tu programa de entrenamiento.',

    // Recommendation
    'recommendation.title': 'Recomendación de Entrenamiento',
    'recommendation.button': 'Agregar entrenamiento',
    'recommendation.generateButton': 'Generar entrenamiento',
    'recommendation.loading': 'Obteniendo recomendación de IA...',
    'recommendation.noHistory': 'No se encontró historial de entrenamientos. Comienza con ejercicios básicos.',
    'recommendation.error': 'Error al obtener recomendación de entrenamiento',
    'recommendation.forDate': 'Entrenamiento recomendado para {date}',
    'recommendation.exercise': 'Ejercicio',
    'recommendation.sets': 'Series',
    'recommendation.reps': 'Repeticiones',
    'recommendation.notes': 'Notas',
    'recommendation.close': 'Cerrar',
    'recommendation.tryWorkout': 'Probar Este Entrenamiento',
    'recommendation.select': 'Seleccionar',
    'recommendation.selectAll': 'Seleccionar Todo',
    'recommendation.selectedCount': '{count} de {total} seleccionados',
    'recommendation.importSelected': 'Importar Seleccionados',
    'recommendation.importing': 'Importando...',
    'recommendation.importSuccess': 'Se importaron exitosamente {count} de {total} {total, plural, one {ejercicio} other {ejercicios}}',
    'recommendation.importError': 'Error al importar ejercicios',
    'recommendation.importPartialError': 'Algunos ejercicios no se pudieron importar: {failed}',
    'recommendation.importNote': 'Los ejercicios seleccionados se importarán con las series y repeticiones mostradas. Los pesos se establecerán en 0 para que los rellenes.',
    'recommendation.description': 'Descripción del Entrenamiento',
    'recommendation.descriptionPlaceholder': 'Describe qué tipo de entrenamiento quieres (ej., "fuerza de tren superior", "cardio y core", "día de piernas con sentadillas")...',
    'recommendation.descriptionHelper': 'Opcional: Describe tus preferencias de entrenamiento para obtener recomendaciones más específicas.',
    'recommendation.generateNew': 'Generar Nuevo',
    'recommendation.showAlternatives': 'Ver Alternativas',

    // Summary View
    'summary.title': 'Resumen de Ejercicios',
    'summary.exercise': 'Ejercicio',
    'summary.lastTrained': 'Último Entrenamiento',
    'summary.maxWeight': 'Peso Máximo (kg)',
    'summary.prDate': 'Fecha del RP',
    'summary.prDetails': 'Detalles del RP',
    'summary.loading': 'Cargando resumen...',
    'summary.error': 'Failed to fetch exercise summaries',

    // Workout Statistics
    'workoutStats.title': 'Estadísticas de Entrenamiento',
    'workoutStats.thisWeek': 'Esta Semana',
    'workoutStats.thisMonth': 'Este Mes',
    'workoutStats.last7Days': 'Últimos 7 Días',
    'workoutStats.last30Days': 'Últimos 30 Días',
    'workoutStats.error': 'Error al cargar estadísticas de entrenamiento',

    // Exercise List View
    'exercise.title': 'Gestionar Ejercicios',
    'exercise.addButton': 'Agregar',
    'exercise.actions': 'Acciones',
    'exercise.exists': 'El ejercicio ya existe',
    'exercise.addError': 'Error al agregar ejercicio',
    'exercise.updateError': 'Error al actualizar ejercicio',
    'exercise.deleteError': 'Error al eliminar ejercicio',
    'exercise.deleteUsedError': 'No se puede eliminar el ejercicio que está siendo usado en entrenamientos. Por favor, eliminalo de todos los entrenamientos primero.',
    'exercise.loading': 'Cargando ejercicios...',
    'exercise.noExercises': 'No hay ejercicios disponibles. ¡Agrega tu primer ejercicio!',
    'exercise.save': 'Guardar',
    'exercise.manageCategories': 'Gestionar Categorías',
    'exercise.close': 'Cerrar',
    'exercise.uncategorized': 'Sin categoría',
    'exercise.category': 'Categoría',
    'exercise.editTitle': 'Editar Ejercicio',
    'exercise.addNew': 'Agregar Nuevo Ejercicio',
    'exercise.adding': 'Agregando...',
    'exercise.saving': 'Guardando...',
    'exercise.validation.nameRequired': 'El nombre del ejercicio es requerido',
    'exercise.validation.categoryRequired': 'La selección de categoría es requerida',

    // Body Weight View
    'bodyweight.progression': 'Progresión del Peso Corporal',
    'bodyweight.fatProgression': 'Progresión del Porcentaje de Grasa',
    'bodyweight.fatMass': 'Masa Grasa (kg)',
    'bodyweight.fatMassProgression': 'Progresión de la Masa Grasa',
    'bodyweight.bmiProgression': 'Progresión de IMC',
    'bodyweight.bmi': 'IMC',
    'bodyweight.loading': 'Cargando datos de peso...',
    'bodyweight.error': 'Failed to fetch body weight logs',

    // Profile
    'profile.title': 'Perfil de Usuario',
    'profile.email': 'Correo Electrónico',
    'profile.birthDate': 'Fecha de Nacimiento',
    'profile.height': 'Altura (cm)',
    'profile.gender': 'Género',
    'profile.gender.male': 'Masculino',
    'profile.gender.female': 'Femenino',
    'profile.gender.other': 'Otro',
    'profile.save': 'Guardar Cambios',
    'profile.saving': 'Guardando...',
    'profile.error': 'Error al actualizar el perfil',
    'profile.success': 'Perfil actualizado exitosamente',
    'profile.language': 'Idioma',
    'profile.goals': 'Objetivos',
    'profile.notes': 'Notas',

    // Profile Setup
    'profileSetup.title': '¡Bienvenido a Lift IQ!',
    'profileSetup.subtitle': 'Configuremos tu perfil para comenzar',
    'profileSetup.step1.title': 'Fecha de Nacimiento',
    'profileSetup.step1.description': '¿Cuándo naciste? Esto nos ayuda a calcular métricas de fitness relacionadas con la edad.',
    'profileSetup.step2.title': 'Altura',
    'profileSetup.step2.description': '¿Cuál es tu altura? Esto nos ayuda a proporcionar mejores recomendaciones de ejercicios.',
    'profileSetup.step3.title': 'Género',
    'profileSetup.step3.description': 'Esta información nos ayuda a personalizar tu experiencia de fitness.',
    'profileSetup.next': 'Siguiente',
    'profileSetup.back': 'Atrás',
    'profileSetup.skip': 'Omitir por ahora',
    'profileSetup.complete': 'Completar Configuración',
    'profileSetup.error': 'Error al completar la configuración del perfil. Por favor, intenta nuevamente.',
    'profileSetup.success.title': '¡Configuración del Perfil Completada!',
    'profileSetup.success.message': '¡Bienvenido a Lift IQ! Estás listo para comenzar tu viaje de fitness.',

    // Service Unavailable (Spanish)
    'serviceUnavailable.title': 'Servicio Iniciándose',
    'serviceUnavailable.message': 'Nuestro servicio backend se está despertando (esto puede tomar hasta 1 minuto en hosting gratuito). Por favor espera un momento e inténtalo de nuevo.',
    'serviceUnavailable.retryButton': 'Reintentar Conexión',
    'serviceUnavailable.autoRetry': 'Auto-reintentar en {seconds} segundos...',
    'serviceUnavailable.disableAutoRetry': 'Desactivar Auto-reintentar',

    // Clone Workouts
    'cloneWorkouts.title': 'Clonar Entrenamientos',
    'cloneWorkouts.button': 'Clonar Entrenamientos',
    'cloneWorkouts.selectDate': 'Selecciona la fecha de origen para clonar entrenamientos:',
    'cloneWorkouts.sourceDate': 'Fecha de Origen',
    'cloneWorkouts.workoutsPreview': 'Entrenamientos a clonar:',
    'cloneWorkouts.noWorkouts': 'No se encontraron entrenamientos para la fecha seleccionada',
    'cloneWorkouts.smartButton': 'Clonar desde el {day} pasado',

    // Import Routine
    'importRoutine.title': 'Importar desde Rutina',
    'importRoutine.button': 'Importar desde Rutina',
    'importRoutine.selectRoutine': 'Seleccionar Rutina',
    'importRoutine.selectDay': 'Seleccionar Día',
    'importRoutine.preview': 'Ejercicios a Importar',
    'importRoutine.allExercisesNote': 'Todos los ejercicios de este día de rutina se importarán con sus series y repeticiones. Los pesos se dejarán vacíos para que los rellenes.',
    'importRoutine.import': 'Importar',
    'importRoutine.importing': 'Importando...',
    'importRoutine.noActiveRoutines': 'No hay rutinas activas disponibles. Crea una rutina activa primero.',
    'importRoutine.loadError': 'Error al cargar rutinas',
    'importRoutine.importError': 'Error al importar desde rutina',

    // Common
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.close': 'Cerrar',
    'common.exportData': 'Exportar Datos',
    'common.exporting': 'Exportando...',
    'common.add': 'Agregar',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.create': 'Crear',
    'common.update': 'Actualizar',
    'common.name': 'Nombre',
    'common.description': 'Descripción',
    'common.notes': 'Notas',
    'common.actions': 'Acciones',
    'common.loading': 'Cargando...',
    'common.noData': 'No hay datos disponibles',
    'common.sharing': 'Compartiendo...',

    // Routines
    'routines.title': 'Rutinas de Entrenamiento',
    'routines.createRoutine': 'Crear Rutina',
    'routines.importFromWorkout': 'Importar desde Entrenamiento',
    'routines.editRoutine': 'Editar Rutina',
    'routines.deleteRoutine': 'Eliminar Rutina',
    'routines.deleteConfirm': '¿Estás seguro de que quieres eliminar esta rutina? Esta acción no se puede deshacer.',
    'routines.routineName': 'Nombre de la Rutina',
    'routines.routineDescription': 'Descripción',
    'routines.isActive': 'Activa',
    'routines.createdAt': 'Creada',
    'routines.days': 'Días',
    'routines.exercises': 'Ejercicios',
    'routines.noDays': 'No hay días configurados',
    'routines.noExercises': 'No hay ejercicios configurados',
    'routines.addDay': 'Agregar Día',
    'routines.editDay': 'Editar Día',
    'routines.deleteDay': 'Eliminar Día',
    'routines.dayNumber': 'Día',
    'routines.dayName': 'Nombre del Día',
    'routines.dayNotes': 'Notas del Día',
    'routines.addExercise': 'Agregar Ejercicio',
    'routines.removeExercise': 'Eliminar Ejercicio',
    'routines.exerciseOrder': 'Orden',
    'routines.exerciseNotes': 'Notas del Ejercicio',
    'routines.sets': 'Series',
    'routines.reps': 'Repeticiones',
    'routines.addSetConfig': 'Agregar Configuración de Serie',
    'routines.removeSetConfig': 'Eliminar Configuración de Serie',
    'routines.setOrder': 'Orden de Serie',
    'routines.setNotes': 'Notas de Serie',
    'routines.noRoutines': 'No hay rutinas disponibles. ¡Crea tu primera rutina!',
    'routines.deleteSuccess': 'Rutina eliminada exitosamente',
    'routines.saveSuccess': 'Rutina guardada exitosamente',
    'routines.loadError': 'Error al cargar rutinas',
    'routines.saveError': 'Error al guardar rutina',
    'routines.deleteError': 'Error al eliminar rutina',
    'routines.selectExercise': 'Seleccionar Ejercicio',
    'routines.dayNamePlaceholder': 'ej., Día de Empuje, Día de Tirón',
    'routines.dayNotesPlaceholder': 'Notas opcionales para este día',
    'routines.exerciseNotesPlaceholder': 'Notas opcionales para este ejercicio',
    'routines.setNotesPlaceholder': 'Notas opcionales para esta configuración de serie',
    'routines.repsPlaceholder': 'ej., 10 o 8-12',

    // Routine Sharing
    'routines.shareRoutine': 'Compartir Rutina',
    'routines.share': 'Compartir',
    'routines.shareSuccess': 'Rutina compartida exitosamente',
    'routines.shareError': 'Error al compartir rutina',
    'routines.sharePartialSuccess': 'Compartida con {successful} de {total} amigos',
    'routines.selectFriends': 'Seleccionar Amigos para Compartir',
    'routines.selectAll': 'Seleccionar Todos',
    'routines.shareMessage': 'Mensaje Opcional',
    'routines.shareMessagePlaceholder': 'Agrega un mensaje personal con tu rutina...',
    'routines.noFriendsToShare': '¡Necesitas amigos para compartir rutinas. Agrega amigos primero!',
    'routines.routineStats': '{days} días, {exercises} ejercicios',
    'routines.myRoutines': 'Mis Rutinas',
    'routines.sharedRoutines': 'Rutinas Compartidas',
    'routines.received': 'Recibidas',
    'routines.sent': 'Enviadas',
    'routines.receivedShares': 'Rutinas Compartidas Contigo',
    'routines.sentShares': 'Rutinas que has Compartido',
    'routines.noReceivedShares': 'Aún no se han compartido rutinas contigo.',
    'routines.noSentShares': 'Aún no has compartido ninguna rutina.',
    'routines.preview': 'Vista Previa',
    'routines.accept': 'Aceptar',
    'routines.decline': 'Rechazar',
    'routines.acceptRoutine': 'Aceptar Rutina',
    'routines.acceptError': 'Error al aceptar rutina',
    'routines.declineError': 'Error al rechazar rutina',
    'routines.loadSharedError': 'Error al cargar rutinas compartidas',
    'routines.sharedBy': 'Compartida por',
    'routines.sharedWith': 'Compartida con',
    'routines.message': 'Mensaje',
    'routines.previewRoutine': 'Vista Previa de Rutina',
    'routines.workoutDays': 'Días de Entrenamiento',
    'routines.day': 'Día',
    'routines.inactive': 'Inactiva',
    'routines.pending': 'Pendiente',
    'routines.accepted': 'Aceptada',
    'routines.declined': 'Rechazada',
    'routines.acceptInfo': 'Aceptar esta rutina creará una copia en tus rutinas. Cualquier ejercicio que no esté en tu biblioteca se creará automáticamente.',
    'routines.confirmAccept': '¿Aceptar Rutina?',
    'routines.confirmDecline': '¿Rechazar Rutina?',
    'routines.confirmAcceptMessage': '¿Estás seguro de que quieres aceptar la rutina "{name}"? Se agregará a tus rutinas.',
    'routines.confirmDeclineMessage': '¿Estás seguro de que quieres rechazar la rutina "{name}"?',
    'routines.cancelShare': 'Cancelar Compartir',
    'routines.routineShared': '¡Rutina compartida exitosamente!',

    // Programas de Entrenamiento
    'programs.title': 'Programas de Entrenamiento',
    'programs.browse': 'Ver Programas',
    'programs.enroll': 'Inscribirse',
    'programs.enrolledSince': 'Inscrito desde',
    'programs.sessionsCompleted': 'Sesiones completadas',
    'programs.status.active': 'Activo',
    'programs.status.paused': 'Pausado',
    'programs.status.completed': 'Completado',
    'programs.nextWorkout': 'Próximo Entrenamiento',
    'programs.startWeights': 'Pesos Iniciales',
    'programs.startingWorkout': 'Entrenamiento Inicial',
    'programs.currentWeight': 'Peso Actual',
    'programs.increment': 'Incremento',
    'programs.deload': 'Descarga',
    'programs.deloadWarning': 'Descarga inminente — 1 fallo más activará una reducción del 10% de peso',
    'programs.logSession': 'Registrar Sesión',
    'programs.sessionLogged': 'Sesión registrada exitosamente',
    'programs.progressChart': 'Gráfico de Progreso',
    'programs.sessionHistory': 'Historial de Sesiones',
    'programs.leave': 'Abandonar Programa',
    'programs.pause': 'Pausar',
    'programs.resume': 'Reanudar',
    'programs.frequency': '{n} días / semana',
    'programs.workoutA': 'Entrenamiento A',
    'programs.workoutB': 'Entrenamiento B',
    'programs.sets': 'Series',
    'programs.reps': 'Repeticiones',
    'programs.succeeded': 'Completado',
    'programs.failed': 'Fallido',
    'programs.noEnrollment': 'Aún no estás inscrito en ningún programa.',
    'programs.enrollConfirm': 'Inscribirse en {name}',
    'programs.leaveConfirm': '¿Estás seguro de que quieres abandonar este programa? Todo tu progreso se perderá.',
    'programs.leaveConfirmTitle': '¿Abandonar Programa?',
    'programs.startWeight': 'Peso Inicial (kg)',
    'programs.exercises': 'Ejercicios',
    'programs.workoutsPerWeek': 'entrenamientos / semana',
    'programs.consecutiveFailures': '{n} fallo(s) — descarga después de 3',
    'programs.noSessions': 'Aún no hay sesiones registradas.',
    'programs.noProgress': 'Aún no hay datos de progresión.',
    'programs.date': 'Fecha',
    'programs.notesOptional': 'Notas (opcional)',
    'programs.defaultWeightHint': 'Déjalo en blanco para usar los valores predeterminados',
    'programs.calendarSession': 'Sesión de Programa',
    'programs.noDetailRecorded': 'Resultados detallados no registrados',
    'programs.deleteSession': 'Eliminar Sesión',
    'programs.deleteSessionConfirm': '¿Estás seguro? Esto revertirá la progresión aplicada en esta sesión.',
    'programs.editSession': 'Editar Sesión',
    'programs.editWeights': 'Editar Pesos Iniciales',
    'programs.sessionDeleted': 'Sesión eliminada y progresión revertida',
    'programs.sessionUpdated': 'Sesión actualizada correctamente',
    'programs.weightsUpdated': 'Pesos iniciales actualizados',
    'programs.cannotEditWeights': 'Los pesos solo se pueden editar antes de tu primera sesión',
    'programs.startWorkout': 'Iniciar Entrenamiento',
    'programs.resumeWorkout': 'Reanudar Entrenamiento',
    'programs.finishWorkout': 'Finalizar Entrenamiento',
    'programs.abandonWorkout': 'Abandonar Entrenamiento',
    'programs.abandonConfirm': '¿Abandonar este entrenamiento? Se perderá tu progreso.',
    'programs.workoutInProgress': 'Entrenamiento en curso',
    'programs.markDone': 'Marcar Hecho',
    'programs.setsDone': '{done} de {total} series completadas',
    'programs.finishIncomplete': 'Tienes {remaining} series pendientes. ¿Finalizar de todas formas?',
    'programs.logManual': 'Registrar Sesión (manual)',
    'programs.startedAt': 'Iniciado',

    // Friends
    'friends.title': 'Amigos',
    'friends.yourFriends': 'Tus Amigos',
    'friends.noFriendsMessage': '¡Aún no tienes amigos. Usa la pestaña "Agregar Amigos" para encontrar y agregar amigos!',
    'friends.friendRequests': 'Solicitudes de Amistad',
    'friends.receivedRequests': 'Solicitudes Recibidas',
    'friends.sentRequests': 'Solicitudes Enviadas',
    'friends.noPendingRequests': 'No hay solicitudes de amistad pendientes.',
    'friends.findFriends': 'Encontrar Amigos',
    'friends.searchByEmail': 'Buscar por correo electrónico',
    'friends.search': 'Buscar',
    'friends.searchResults': 'Resultados de Búsqueda',
    'friends.noUsersFound': 'No se encontraron usuarios con esa dirección de correo electrónico.',
    'friends.friendsTab': 'Amigos ({count})',
    'friends.requestsTab': 'Solicitudes ({count})',
    'friends.addFriendsTab': 'Agregar Amigos',
    'friends.addFriend': 'Agregar Amigo',
    'friends.statusFriends': 'Amigos',
    'friends.statusRequestSent': 'Solicitud Enviada',
    'friends.statusRequestReceived': 'Solicitud Recibida',
    'friends.statusDeclined': 'Rechazado',
    'friends.statusBlocked': 'Bloqueado',
    'friends.statusPending': 'Pendiente',
    'friends.loadError': 'Error al cargar amigos',
    'friends.searchError': 'Error al buscar usuarios',
    'friends.sendRequestError': 'Error al enviar solicitud de amistad',
    'friends.acceptRequestError': 'Error al aceptar solicitud de amistad',
    'friends.declineRequestError': 'Error al rechazar solicitud de amistad',
    'friends.removeError': 'Error al eliminar amigo',
    'friends.confirmRemoveTitle': 'Confirmar Eliminación de Amigo',
    'friends.confirmRemoveMessage': '¿Estás seguro de que quieres eliminar a {friendName} de tu lista de amigos?',
    'friends.remove': 'Eliminar',

    // Workout Sharing
    'workoutShare.title': 'Compartir Entrenamiento',
    'workoutShare.selectFriend': 'Seleccionar Amigo',
    'workoutShare.selectExercises': 'Seleccionar Ejercicios',
    'workoutShare.exerciseName': 'Nombre del Ejercicio',
    'workoutShare.sets': 'Series',
    'workoutShare.reps': 'Repeticiones',
    'workoutShare.addExercise': 'Agregar Ejercicio',
    'workoutShare.removeExercise': 'Eliminar',
    'workoutShare.message': 'Mensaje Opcional',
    'workoutShare.messagePlaceholder': 'Agrega un mensaje personal con tu entrenamiento...',
    'workoutShare.share': 'Compartir Entrenamiento',
    'workoutShare.cancel': 'Cancelar',
    'workoutShare.shareSuccess': 'Entrenamiento compartido exitosamente',
    'workoutShare.shareError': 'Error al compartir entrenamiento',
    'workoutShare.noFriendsToShare': '¡Necesitas amigos para compartir entrenamientos. Agrega amigos primero!',
    'workoutShare.atLeastOneExercise': 'Agrega al menos un ejercicio para compartir',
    'workoutShare.sharedWorkouts': 'Entrenamientos Compartidos',
    'workoutShare.receivedShares': 'Entrenamientos Compartidos Contigo',
    'workoutShare.sentShares': 'Entrenamientos que has Compartido',
    'workoutShare.noReceivedShares': 'Aún no se han compartido entrenamientos contigo.',
    'workoutShare.noSentShares': 'Aún no has compartido ningún entrenamiento.',
    'workoutShare.preview': 'Vista Previa',
    'workoutShare.accept': 'Aceptar',
    'workoutShare.decline': 'Rechazar',
    'workoutShare.acceptWorkout': 'Aceptar Entrenamiento',
    'workoutShare.acceptError': 'Error al aceptar entrenamiento',
    'workoutShare.declineError': 'Error al rechazar entrenamiento',
    'workoutShare.loadSharedError': 'Error al cargar entrenamientos compartidos',
    'workoutShare.sharedBy': 'Compartido por',
    'workoutShare.sharedWith': 'Compartido con',
    'workoutShare.exercises': 'Ejercicios',
    'workoutShare.previewWorkout': 'Vista Previa del Entrenamiento',
    'workoutShare.selectDate': 'Seleccionar Fecha para Importar',
    'workoutShare.targetDate': 'Importar a Fecha',
    'workoutShare.acceptInfo': 'Aceptar este entrenamiento importará los ejercicios a tu fecha seleccionada. Cualquier ejercicio que no esté en tu biblioteca se creará automáticamente.',
    'workoutShare.confirmAccept': '¿Aceptar Entrenamiento?',
    'workoutShare.confirmDecline': '¿Rechazar Entrenamiento?',
    'workoutShare.confirmAcceptMessage': '¿Estás seguro de que quieres aceptar este entrenamiento? Se importará a tu fecha seleccionada.',
    'workoutShare.confirmDeclineMessage': '¿Estás seguro de que quieres rechazar este entrenamiento?',
    'workoutShare.acceptSuccess': 'Entrenamiento aceptado e importado exitosamente',
    'workoutShare.declineSuccess': 'Entrenamiento rechazado',
    'workoutShare.pending': 'Pendiente',
    'workoutShare.accepted': 'Aceptado',
    'workoutShare.declined': 'Rechazado',
    'workoutShare.fillAllFields': 'Por favor completa todos los campos del ejercicio',
    'workoutShare.exerciseOrder': 'Ejercicio {order}',

    // Notifications
    'notifications.title': 'Notificaciones',
    'notifications.noNotifications': 'No hay notificaciones nuevas',
    'notifications.friendRequest': 'Solicitud de Amistad',
    'notifications.friendRequestAccepted': 'Solicitud de Amistad Aceptada',
    'notifications.routineShare': 'Rutina Compartida',
    'notifications.routineShareAccepted': 'Rutina Compartida Aceptada',
    'notifications.workoutShare': 'Entrenamiento Compartido',
    'notifications.workoutShareAccepted': 'Entrenamiento Compartido Aceptado',
    'notifications.friendRequestAcceptedFrom': '{name} aceptó tu solicitud de amistad',
    'notifications.friendRequestFrom': '{name} te envió una solicitud de amistad',
    'notifications.routineShareFrom': '{name} compartió una rutina contigo',
    'notifications.routineShareAcceptedFrom': '{name} aceptó tu solicitud de compartir la rutina "{routineName}"',
    'notifications.workoutShareFrom': '{name} compartió un entrenamiento contigo',
    'notifications.workoutShareAcceptedFrom': '{name} aceptó tu entrenamiento compartido',
    'notifications.viewFriends': 'Ver Amigos',
    'notifications.viewSharedRoutines': 'Ver Rutinas Compartidas',
    'notifications.markAllRead': 'Marcar Todo Como Leído',
    'notifications.clearAll': 'Eliminar Todas las Notificaciones',
    'notifications.error': 'Error al cargar notificaciones',

    // Import Workout
    'importWorkout.title': 'Importar Entrenamiento a Rutina',
    'importWorkout.selectRoutine': 'Seleccionar Rutina',
    'importWorkout.selectDate': 'Seleccionar Fecha de Entrenamiento',
    'importWorkout.dayName': 'Nombre del Día',
    'importWorkout.dayNamePlaceholder': 'ej., Día de Empuje, Día de Tirón',
    'importWorkout.dayNotes': 'Notas del Día',
    'importWorkout.dayNotesPlaceholder': 'Notas opcionales para este día de rutina',
    'importWorkout.workoutPreview': 'Vista Previa del Entrenamiento',
    'importWorkout.exercisesToImport': 'Ejercicios a importar',
    'importWorkout.sets': 'series',
    'importWorkout.importNote': 'Las series y repeticiones se convertirán al formato de rutina como valores objetivo',
    'importWorkout.noWorkoutsFound': 'No se encontraron entrenamientos para esta fecha',
    'importWorkout.previewError': 'Error al cargar la vista previa del entrenamiento',
    'importWorkout.importError': 'Error al importar entrenamiento a rutina',
    'importWorkout.importSuccess': 'Entrenamiento importado a rutina exitosamente',
    'importWorkout.import': 'Importar',
    'importWorkout.importing': 'Importando...',

    // Release Notes
    'releaseNotes.title': '¿Qué es nuevo?',
    'releaseNotes.new': 'Nuevo',
    'releaseNotes.fix': 'Corrección',
    'releaseNotes.improvement': 'Mejora',

    // Recent Workouts
    'recentWorkouts.title': 'Entrenamientos Recientes para {exerciseName}',
    'recentWorkouts.noData': 'No se encontraron entrenamientos recientes para este ejercicio.',
    'recentWorkouts.set': 'Serie {series}: {reps} repeticiones con {weight} kg',

    // Chat
    'chat.title': 'Asistente de Fitness',
    'chat.placeholder': 'Haz una pregunta sobre tus entrenamientos...',
    'chat.send': 'Enviar',
    'chat.voice.start': 'Voz',
    'chat.voice.stop': 'Detener',
    'chat.voice.unsupported': 'Entrada por voz no soportada en este navegador',
    'chat.listening': 'Escuchando…',
    'chat.voice.lang': 'es-ES',

    // Evaluation
    'evaluation.title': 'Sistema de Evaluación de Análisis IA',
    'evaluation.description': 'Prueba y valida respuestas de análisis de entrenamientos IA usando múltiples modelos y criterios de evaluación comprensivos.',
    'evaluation.devWarning': '⚠️ Herramienta de Desarrollador: Este sistema de evaluación es solo para propósitos de prueba y desarrollo.',
    'evaluation.tabs.runEvaluation': 'Ejecutar Evaluación',
    'evaluation.tabs.testCases': 'Casos de Prueba',
    'evaluation.tabs.resultsHistory': 'Historial de Resultados',

    // Evaluation Runner
    'evaluation.runner.title': 'Configurar Evaluación',
    'evaluation.runner.selectTestCase': 'Cargar Caso de Prueba (Opcional)',
    'evaluation.runner.testCaseHelper': 'Selecciona un caso de prueba para auto-completar el formulario',
    'evaluation.runner.noTestCase': 'Ninguno - Entrada Manual',
    'evaluation.runner.selectUser': 'Seleccionar Usuario',
    'evaluation.runner.startDate': 'Fecha de Inicio',
    'evaluation.runner.endDate': 'Fecha de Fin',
    'evaluation.runner.goal': 'Objetivo del Análisis',
    'evaluation.runner.goalHelp': 'Opcional: Especifica qué analizar (ej., "grupos musculares", "progreso de fuerza")',
    'evaluation.runner.language': 'Idioma',
    'evaluation.runner.modelSelection': 'Selección de Modelo',
    'evaluation.runner.both': 'Comparar Ambos',
    'evaluation.runner.run': 'Ejecutar Evaluación',
    'evaluation.runner.running': 'Ejecutando...',
    'evaluation.runner.requiredFields': 'Por favor completa todos los campos requeridos',
    'evaluation.runner.error': 'Error al ejecutar la evaluación. Inténtalo de nuevo.',

    // Test Cases
    'evaluation.testCases.title': 'Casos de Prueba',
    'evaluation.testCases.create': 'Crear Caso de Prueba',
    'evaluation.testCases.empty': 'No hay casos de prueba aún. Crea uno para comenzar.',
    'evaluation.testCases.goal': 'Objetivo',
    'evaluation.testCases.requiredFields': 'Por favor completa todos los campos requeridos',
    'evaluation.testCases.createError': 'Error al crear caso de prueba',
    'evaluation.testCases.createDialog.title': 'Crear Caso de Prueba',
    'evaluation.testCases.createDialog.name': 'Nombre',
    'evaluation.testCases.createDialog.description': 'Descripción',
    'evaluation.testCases.createDialog.user': 'Usuario',
    'evaluation.testCases.createDialog.startDate': 'Fecha de Inicio',
    'evaluation.testCases.createDialog.endDate': 'Fecha de Fin',
    'evaluation.testCases.createDialog.goalType': 'Tipo de Objetivo',
    'evaluation.testCases.createDialog.goalTypeHelp': 'Selecciona objetivo de análisis predefinido o elige personalizado',
    'evaluation.testCases.createDialog.customGoal': 'Objetivo Personalizado',
    'evaluation.testCases.createDialog.language': 'Idioma',
    'evaluation.testCases.createDialog.expectedTopics': 'Temas Esperados',
    'evaluation.testCases.createDialog.expectedTopicsHelp': 'Lista separada por comas de temas que deberían cubrirse (auto-completado para objetivos predefinidos)',

    // Results History
    'evaluation.history.title': 'Historial de Resultados de Evaluación',
    'evaluation.history.empty': 'No hay ejecuciones de evaluación aún. Ejecuta una evaluación para ver resultados aquí.',
    'evaluation.history.loading': 'Cargando resultados...',
    'evaluation.history.loadError': 'Error al cargar resultados',
    'evaluation.history.runInfo': 'Información de Ejecución',
    'evaluation.history.testCase': 'Caso de Prueba',
    'evaluation.history.dateRange': 'Rango de Fechas',
    'evaluation.history.runDate': 'Fecha de Ejecución',
    'evaluation.history.view': 'Ver Detalles',
    'evaluation.history.delete': 'Eliminar',
    'evaluation.history.confirmDelete': '¿Estás seguro de que quieres eliminar esta ejecución de evaluación?',

    // Results
    'evaluation.results.title': 'Resultados de Evaluación',
    'evaluation.results.exportJson': 'Exportar JSON',
    'evaluation.results.exportCsv': 'Exportar CSV',
    'evaluation.results.comparisonSummary': 'Comparación de Modelos',
    'evaluation.results.responses': 'Respuestas IA',
    'evaluation.results.viewResponse': 'Ver Respuesta Completa',

    // Criteria
    'evaluation.criteria.relevance': 'Relevancia',
    'evaluation.criteria.dataUtilization': 'Utilización de Datos',
    'evaluation.criteria.accuracy': 'Precisión',
    'evaluation.criteria.specificity': 'Especificidad',
    'evaluation.criteria.languageConsistency': 'Consistencia de Idioma',
    'evaluation.criteria.format': 'Formato',
    'evaluation.criteria.completeness': 'Completitud',
    'evaluation.criteria.safety': 'Seguridad',
    'evaluation.criteria.score': 'Puntuación',
    'evaluation.criteria.viewDetails': 'Ver Detalles',
    'evaluation.criteria.reasoning': 'Razonamiento Detallado',

    // Wrapped 2025
    'wrapped.title': 'LIFT IQ WRAPPED 2025',
    'wrapped.subtitle': 'Tu Año en Lift IQ',
    'wrapped.totalWorkouts': 'Entrenamientos Totales',
    'wrapped.tonnesLifted': 'Toneladas Levantadas',
    'wrapped.topExercises': 'Ejercicios Top',
    'wrapped.consistency': 'Chequeo de Consistencia',
    'wrapped.greatWork': '¡Gran trabajo en 2025!',
    'wrapped.keepPushing': 'Sigue empujando tus límites. Nos vemos en el gimnasio.',
    'wrapped.share': 'Compartir Mis Estadísticas',
    'wrapped.shareTitle': 'Mi Lift IQ Wrapped 2025',
    'wrapped.shareMessage': '¡Completé {workouts} entrenamientos y levanté {tonnes} toneladas en 2025! #LiftIQ',
    'wrapped.error': 'No se pudo cargar tu Lift IQ Wrapped de 2025. ¿Quizás no has entrenado lo suficiente todavía? 😉',
    'wrapped.noExercises': 'No hay ejercicios registrados todavía.',
    'wrapped.navTitle': 'Wrapped 2025',

    // Months Short
    'monthsShort.jan': 'Ene',
    'monthsShort.feb': 'Feb',
    'monthsShort.mar': 'Mar',
    'monthsShort.apr': 'Abr',
    'monthsShort.may': 'May',
    'monthsShort.jun': 'Jun',
    'monthsShort.jul': 'Jul',
    'monthsShort.aug': 'Ago',
    'monthsShort.sep': 'Sep',
    'monthsShort.oct': 'Oct',
    'monthsShort.nov': 'Nov',
    'monthsShort.dec': 'Dic',

    // AI Workout Wizard
    'aiWizard.steps.location': 'Ubicación',
    'aiWizard.steps.muscles': 'Músculos',
    'aiWizard.steps.type': 'Tipo',
    'aiWizard.steps.duration': 'Duración',
    'aiWizard.steps.level': 'Nivel',
    'aiWizard.steps.exercises': 'Ejercicios',
    'aiWizard.steps.summary': 'Resumen',
    'aiWizard.step_counter': 'Paso {current} de {total}',
    'aiWizard.muscles.title': 'Grupos Musculares Objetivo',
    'aiWizard.muscles.subtitle': 'No selecciones ninguno para cuerpo completo',
    'aiWizard.muscles.chest': 'Pecho',
    'aiWizard.muscles.back': 'Espalda',
    'aiWizard.muscles.shoulders': 'Hombros',
    'aiWizard.muscles.abs': 'Abdominales',
    'aiWizard.muscles.quadriceps': 'Cuádriceps',
    'aiWizard.muscles.hamstrings': 'Isquiotibiales',
    'aiWizard.muscles.glutes': 'Glúteos',
    'aiWizard.muscles.calves': 'Gemelos',
    'aiWizard.muscles.adductors': 'Aductores',
    'aiWizard.muscles.biceps': 'Bíceps',
    'aiWizard.muscles.triceps': 'Tríceps',
    'aiWizard.muscles.cardio': 'Cardio/Correr',
    'aiWizard.muscles.swimming': 'Natación',
    'aiWizard.duration.minutes': 'Tiempo (Minutos)',
    'aiWizard.duration.exercises': 'Número de Ejercicios',
    'aiWizard.duration.targetTime': 'Tiempo Objetivo: {value} minutos',
    'aiWizard.duration.targetCount': 'Objetivo: {value} ejercicios',
    'review.title': 'Revisa tu Entrenamiento',
    'review.overview.subtitle': 'Aquí tienes el plan propuesto. Vamos a revisarlo ejercicio por ejercicio.',
    'review.step.sets': 'Series',
    'review.step.reps': 'Repeticiones',
    'review.step.recommended': 'Recomendado: {value}',
    'review.step.notes': 'Notas',
    'review.step.swap': 'Cambiar Ejercicio',
    'review.step.remove': 'Eliminar Ejercicio',
    'review.step.skip': 'Omitir Ejercicio',
    'review.step.skipped': 'Omitido',
    'review.button.start': 'Comenzar Revisión',
    'review.button.finish': 'Importar Entrenamiento',
    'review.summary.ready': '¡Listo para Entrenar!',
    'review.summary.subtitle': 'Tu entrenamiento con {count} ejercicios está listo para importar.',
    'aiWizard.exercises.title': '¿Usar solo tu biblioteca de ejercicios?',
    'aiWizard.exercises.description': 'Si se habilita, la IA intentará recomendar solo ejercicios que ya hayas creado. Esto es bueno para mantener limpio tu historial, pero podría limitar la creatividad.',
    'aiWizard.exercises.yes': 'Sí, usar mis ejercicios',
    'aiWizard.exercises.no': 'No, permitir nuevos ejercicios',
    'aiWizard.exercises.count': '{count} ejercicios disponibles en tu biblioteca.',
    'aiWizard.summary.location': 'Ubicación',
    'aiWizard.summary.muscles': 'Músculos',
    'aiWizard.summary.type': 'Tipo',
    'aiWizard.summary.target': 'Objetivo',
    'aiWizard.summary.level': 'Nivel',
    'aiWizard.summary.source': 'Fuente de Ejercicios',
    'aiWizard.summary.fullBody': 'Cuerpo Completo',
    'aiWizard.summary.libraryOnly': 'Solo Mi Biblioteca',
    'aiWizard.summary.any': 'Cualquiera',
    'aiWizard.summary.ready': '¿Listo para generar? Esto puede tardar unos segundos.',
    'aiWizard.button.back': 'Atrás',
    'aiWizard.button.next': 'Siguiente',
    'aiWizard.button.generate': 'Generar Entrenamiento',
    'aiWizard.button.generating': 'Generando...',
    'aiWizard.button.undo': 'Deshacer',
    'aiWizard.location.home': 'En Casa',
    'aiWizard.location.homeDesc': 'Equipo limitado, enfoque en peso corporal',
    'aiWizard.location.gym': 'En el Gimnasio',
    'aiWizard.location.gymDesc': 'Acceso completo al equipo',
    'aiWizard.type.hypertrophy': 'Hipertrofia',
    'aiWizard.type.hypertrophyDesc': 'Enfoque en crecimiento muscular (8-12 reps)',
    'aiWizard.type.strength': 'Fuerza',
    'aiWizard.type.strengthDesc': 'Enfoque en potencia bruta (1-6 reps)',
    'aiWizard.type.resistance': 'Resistencia',
    'aiWizard.type.resistanceDesc': 'Más repeticiones, menos descanso',
    'aiWizard.level.beginner': 'Principiante',
    'aiWizard.level.beginnerDesc': 'Enfoque en fundamentos y forma',
    'aiWizard.level.experienced': 'Experimentado',
    'aiWizard.level.experiencedDesc': 'Técnicas avanzadas y mayor volumen',
    'recommendation.error.generic': 'No pudimos generar un entrenamiento en este momento. Por favor inténtalo de nuevo más tarde.',
  },
};